import { Box, Card } from '@betterment/style-closet-react';

import { TextShimmerLoader } from '../../Shared/components/ShimmerLoaders';

const ShimmerLoader = ({ mt = '0' }) => {
  return (
    <Box mt={mt}>
      <Card>
        <Card.Slot name="body">
          <TextShimmerLoader numLines={2} />
        </Card.Slot>
      </Card>
    </Box>
  );
};

export default ShimmerLoader;
